import React, { useLayoutEffect, useRef, useState } from "react";
import { ReactComponent as Arrow } from "svgs/arrow-right.svg";
import FeatureSelector from "./feature-dropdown";
import ButtonSwitch from "./button-switch";

const CylindoViewer = ({ code, frame = 1, initialFeatures = [], dynamicFeature, curator = "", isPreview = false }) => {
	const [features, setFeatures] = useState(initialFeatures);
	const [activeFeature, setActiveFeature] = useState("");
	const viewerRef = useRef(null);

	const dynamicFeatureLayout = dynamicFeature?.layout;
	const dynamicFeatureKey = dynamicFeature?.key?.split("=")[0];

	const updateFeatures = () => {
		viewerRef.current.features = Object.fromEntries(
			features.map((feature) => {
				const [key, value] = feature.split(":");
				return [key, value];
			})
		);
	};

	const handleFeatureSelect = (newFeature) => {
		const updatedFeatures = features.filter((feature) => feature.toLowerCase() !== dynamicFeatureKey.toLowerCase());
		const featureValue = newFeature.split("=")[0];
		const featureKey = dynamicFeature?.key?.split("=")[0];

		updatedFeatures.push(`${featureKey}:${featureValue}`);
		setFeatures(updatedFeatures);
		setActiveFeature(newFeature);
	};

	useLayoutEffect(() => {
		if (!features.length || !viewerRef.current || isPreview) return;

		if (viewerRef.current.features) {
			updateFeatures();
		} else {
			viewerRef.current.addEventListener("ready", updateFeatures);
		}
	}, [features, isPreview]);

	const imageUrl = `http://content.cylindo.com/api/v2/6127/products/${code}${frame ? `/frames/${frame}.png` : ".png"}
    ${features?.length > 0 ? `?${features.map(f => `feature=${encodeURI(f)}`).join("&")}` : ""}`;

	const defaultValue = dynamicFeature?.values?.find((value) => {
		const feature = features.find((f) => f.split(":")[0] === dynamicFeatureKey);
		return feature && value.includes(feature.split(":")[1]);
	});

	const props = {
		dynamicFeature,
		activeFeature,
		initialFeatures,
		defaultValue,
		onFeatureSelect: handleFeatureSelect,
	};

	return isPreview ? (
		<img src={imageUrl} className="cylindo-thumb" loading="lazy" alt="cylindo" />
	) : (
		<div className="relative">
			{dynamicFeature?.enabled && (
				<>
					{dynamicFeatureLayout === "dropdown" && <FeatureSelector {...props} />}
					{dynamicFeatureLayout === "switchButton" && <ButtonSwitch {...props} />}
				</>
			)}
			<cylindo-viewer ref={viewerRef} remote-config={curator} controls="qr zoom indicators">
				<img slot="placeholder" src={imageUrl} loading="lazy" alt="cylindo" />
				<cylindo-360
					frame={frame}
					interaction-prompt="auto"
					remove-environment-shadow="false"
				></cylindo-360>
			</cylindo-viewer>
			<div className="cylindo-drag-tooltip">
				<Arrow className="rotate-180 scale-75" />
				<div className="px-2 py-1.5">Drag to rotate</div>
				<Arrow className="scale-75" />
			</div>
		</div>
	);
};

export default CylindoViewer;